import * as angular from "angular";

angular
  .module('bringoz.admin.service-analysis')
  .filter('logStatusFilter', logStatusFilter);

/* @ngInject */
function logStatusFilter($filter) {
  return function logStatusFilter(log) {
    return log.canceled ? $filter('translate')('Canceled') :
      (log.failed ? $filter('translate')('Failed') : $filter('translate')('Done'))
  }
}
